module.exports = __webpack_public_path__ + "img/bg.d8089f45.png";